import React from 'react';
import Modal from '../../../client/components/Modal';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import AuthForm from '../AuthForm';
import CloseIconPng from '../images/button_menu_close.png';
import CloseIconSvg from '../images/button_menu_close.svg';
import styles from './index.sass';

class AuthModal extends React.Component {
  static propTypes = {
    onClose: React.PropTypes.func,
    mode: React.PropTypes.string,
    email: React.PropTypes.string
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnCloseModal() {
    this.props.onClose && this.props.onClose();
  }

  handleOnSignIn() {
    this.props.onClose && this.props.onClose(true);
  }

  handleOnPasswordResetRequested() {
    this.props.onClose && this.props.onClose(true);
  }

  render() {
    let modalProps = {
      onClose   : this.handleOnCloseModal.bind(this),
      className : styles.authModal
    };
    let authFormProps = {
      mode: this.props.mode,
      email: this.props.email,
      customer: this.props.customer,
      requestStatus: this.props.requestStatus,
      error: this.props.error,
      onSignIn: this.handleOnSignIn.bind(this),
      onPasswordResetRequested: this.handleOnPasswordResetRequested.bind(this)
    };
    let closeButtonProps = {
      className: styles.closeButton,
      onClick: this.handleOnCloseModal.bind(this)
    };

    return (
      <Modal {...modalProps}>
        <AuthForm {...authFormProps} />
        <button {...closeButtonProps}><img src={CloseIconPng} srcSet={CloseIconSvg} /></button>
      </Modal>
    );
  }
}

AuthModal = connectToStores(AuthModal, [CustomerStore], (context, props) => {
  let customerStore = context.getStore(CustomerStore);
  return {
    customer: customerStore.getCurrentCustomer(),
    requestStatus: customerStore.getCurrentRequestStatus(),
    error: customerStore.getCurrentError()
  };
});

export default AuthModal;



// WEBPACK FOOTER //
// banquet/components/AuthModal/index.js